const map = {
  ErpAssemblyTemplateList: () => import('@/views/supplyChain/ErpAssemblyTemplate/index'),
  ErpAssemblyTemplateDetail: () => import('@/views/supplyChain/ErpAssemblyTemplate/Detail'),
  ErpDisassemblyOrderDetail: () => import('@/views/supplyChain/ErpDisassemblyOrder/Detail'),

  ErpAssemblyOrderDetail: () => import('@/views/supplyChain/ErpAssemblyOrder/Detail'),

  PostdataCreatePoCost: () => import('@/views/supplyChain/PostdataCreatePoCost/index'), // 对账申请单
  DocumentTypeconfig: () => import('@/views/supplyChain/DocumentTypeconfig/index'), // 单据类型配置
  ErpStockOutOrder: () => import('@/views/supplyChain/ErpStockOutOrder/index'), // 下游单据
  ErpStockInOrder: () => import('@/views/supplyChain/ErpStockInOrder/index') // 下游单据
}

export default map
